
import { Base } from '../../components/base-component';

import { AnalyticsService } from '../../services/analytics.service';

import './form-item-agri-business-finance-farmers.component.scss';

export class FormItemAgriBusinessFinanceFarmers extends Base {

	form: HTMLFormElement;
	submitBtn: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = this.element.querySelector('.js-agri-business-finance-farmers__button');

	}

	bindEvents() {

		this.submitBtn.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.actionForm(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		});
	}

	actionForm(form: HTMLFormElement, loader: Element, thankyou: Element) {

		let _records = [];
		let name = Array.from(form.querySelectorAll('.form__success-container__firstname'));

		// paremeters
		let serviceType: any = form.querySelector("input[name=serviceType]");
		let product: any = form.querySelector("input[name=product]");
		let email: any = form.querySelector("input[name=email]");
		let recipient: any = form.querySelector("input[name=recipient]");
		let subject: any = form.querySelector("input[name=subject]");
		let description: any = form.querySelector("input[name=description]");
		let redirect: any = form.querySelector("input[name=redirect]");

		let _firstName: any = this.form.querySelector('input[name=firstName]');
		let _lastName: any = this.form.querySelector('input[name=lastName]');
		let _phoneNumber: any = this.form.querySelector('input[name=phoneNumber]');
		let _deliveryAddress1: any = this.form.querySelector('input[name=deliveryAddress1]');
		let _deliveryAddress2: any = this.form.querySelector('input[name=deliveryAddress2]');
		let _deliveryAddress3: any = this.form.querySelector('input[name=deliveryAddress3]');
		let _areaCode: any = this.form.querySelector('input[name=areaCode]');

		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');

		let postData = '';

		if (serviceType) {
			postData += 'service-type=' + serviceType.value;
		}
		if (product) {
			postData += '&product=' + product.value;
		}
		if (email) {
			postData += '&email=' + email.value;
		}
		if (recipient) {
			postData += '&recipient=' + recipient.value;
		}
		if (subject) {
			postData += '&subject=' + subject.value;
		}
		if (description) {
			postData += '&description=' + description.value;
		}
		if (redirect) {
			postData += '&redirect=' + redirect.value;
		}


		if (_firstName) {
			postData += '&firstname=' + _firstName.value;
		}
		if (_lastName) {
			postData += '&surname=' + _lastName.value;
		}
		if (_phoneNumber) {
			postData += '&contact=' + _phoneNumber.value;
		}
		if (_deliveryAddress1) {
			postData += '&deliveryaddress1=' + _deliveryAddress1.value;
		}
		if (_deliveryAddress2) {
			postData += '&deliveryaddress2=' + _deliveryAddress2.value;
		}
		if (_deliveryAddress3) {
			postData += '&deliveryaddress3=' + _deliveryAddress3.value;
		}
		if (_areaCode) {
			postData += '&areacode=' + _areaCode.value;
		}

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitGenericForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(function (response) {
			//Always show success message / no response from server (sending email)
			analyticsService.dtmFormComplete('complete', response.code);
			loader.classList.remove('active');
			thankyou.classList.add('active');
			success.classList.add('active');
			error.classList.add('hidden');
		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-agri-business-finance-farmers/form-item-agri-business-finance-farmers.component.ts